<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="任务指派"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="360px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="部门：" prop="departmentId" class="mr0">
          <el-select
            size="mini"
            v-model="form.departmentId"
            filterable
            placeholder="请选择部门"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchDepartmentList"
            @visible-change="searchDepartmentList('')"
            @change="chooseDepartment"
          >
            <el-option
              v-for="item in departmentList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工：">
          <el-select
            size="mini"
            v-model="form.userId"
            filterable
            placeholder="请选择员工"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchUserList"
            @visible-change="searchUserList('')"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目：">
          <el-select
            size="mini"
            v-model="form.projectId"
            filterable
            placeholder="请选择项目"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchProjectList"
            @visible-change="searchProjectList('')"
            @change="chooseProject"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.projectName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯：" prop="liftId" class="mr0">
          <el-select
            size="mini"
            v-model="form.liftId"
            filterable
            placeholder="请选择电梯"
            clearable
            reserve-keyword
            :multiple="!editData"
            collapse-tags
            :remote="true"
            :remote-method="searchLiftList"
            @visible-change="searchLiftList('')"
          >
            <el-option
              v-for="item in liftList"
              :key="item.liftId"
              :label="item.liftLocation"
              :value="item.liftId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期：">
          <el-date-picker
            v-model="form.startTime"
            type="date"
            size="mini"
            @change="changeStartTime"
            placeholder="请选择开始日期"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            @change="chooseEndTime"
            size="mini"
            placeholder="请选择结束日期"
            prefix-icon=" "
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        :loading="loading"
        type="primary"
        size="mini"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { saveAssign, saveBatch } from "@/api/TaskAssigned";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import { getLiftSimpleList, getUserSimpleList } from "@/api/MaintenancePlan";
import { getDepartmentSimpleList } from "@/api/UserManagement";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        projectId: "",
        liftId: [],
        endTime: "",
        startTime: new Date(),
        departmentId: "",
        userId: "",
      },
      projectList: [],
      liftList: [],
      rules: {},
      loading: false,
      departmentList: [],
      userList: [],
    };
  },
  props: ["editData"],
  computed: {
    ...mapState("userStore/user", ["user"]),
  },
  mounted() {
    if (this.editData && this.editData.id) {
      this.form = { ...this.editData };

      this.searchUserList();
      this.searchDepartmentList();
      this.searchProjectList();
      this.searchLiftList();
    }

  },
  methods: {
    async searchUserList(keyword) {
      const res = await getUserSimpleList({
        keyword: keyword,
        size: 100,
        departmentIdList: this.form.departmentId
          ? [this.form.departmentId]
          : null,
      });
      if (res.code === 200) {
        this.userList = res.data;
      }
    },
    async searchDepartmentList(keyword) {
      const res = await getDepartmentSimpleList({
        keyword: keyword,
        size: 100,
        unitId: this.user.unitId,
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    chooseEndTime(val) {
      if (val && this.form.startTime) {
        if (new Date(this.form.startTime).valueOf() > new Date(val).valueOf()) {
          this.form.endTime = "";
        }
      }
    },
    changeStartTime(val) {
      if (val && this.form.endTime) {
        if (new Date(this.form.endTime) < new Date(val)) {
          this.form.startTime = "";
        }
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchLiftList(keyword) {
      if (!this.form.projectId) {
        return;
      }
      const res = await getLiftSimpleList({
        keyword: keyword,
        size: 100,
        projectId: this.form.projectId,
      });
      if (res.code === 200) {
        this.liftList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const params = {
            ...this.form,
            userId: this.form.userId || this.user.id,
          };
          this.loading = true;
          let postFun = saveBatch;
          if (this.editData && this.editData.id) {
            postFun = saveAssign;
          }
          const res = await postFun(params);
          if (res.code === 200) {
            this.$message.success("保存成功");
            this.$emit("confirm");
          }
          this.loading = false;
        }
      });
    },
    chooseDepartment() {
      this.form.userId = null;
    },
    chooseProject() {
      this.form.liftId = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/TaskAssigned/components/AddAssigne.vue